import { render, staticRenderFns } from "./ReminderItem.vue?vue&type=template&id=2bc1594a&"
import script from "./ReminderItem.vue?vue&type=script&lang=js&"
export * from "./ReminderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports